import Painterro from 'painterro';

Painterro.default({
    id: 'painterro',
    colorScheme: {
        main: '#f8f8f8',
        control: '#f8f8f8',
        backgroundColor: '#f8f8f8',
        controlShadow: 'none',
        active: '#000000',
    },
}).show();
